const locale = {
  UPSERT_TITLE_TEXT: 'Agregado exitosamente',
  UPSERT_DESCRIPTION_TEXT: 'Este curso ahora está en tu colección.',
  ERROR_UPSERT_TITLE_TEXT: 'No se pudo guardar el curso',
  ERROR_UPSERT_DESCRIPTION_TEXT: 'Algo salió mal. Por favor, inténtalo de nuevo.',
  VIEW_COURSES_LINK_TEXT: 'Ir a Tus Colecciones',
  VIEW_ALL_SAVED_COURSES_LINK_TEXT: 'Ir a Todos los Cursos Guardados',
  DELETE_TITLE_TEXT: 'Curso eliminado',
  DELETE_DESCRIPTION_TEXT: 'Este curso ya no está en tus colecciones.',
  ERROR_TITLE_TEXT: 'Error',
  ERROR_DESCRIPTION_TEXT: 'Algo salió mal. Por favor, inténtalo de nuevo.',
  UNDO_ACTION_TEXT: 'Deshacer',
};

export default locale;
